// Tiny logger that's a no-op in production but visible during development.
// Use logError(...) instead of console.error(...) inside catch blocks so:
//  - dev/local debugging keeps full visibility
//  - production builds emit nothing (no console clutter, no info leakage)
//
// Why a helper: the static analyzer flags every raw `console.error` as a
// "production console statement" even when it's the ONLY error visibility we
// have inside fetch catches. Routing through this helper means a single
// approved location instead of N scattered NODE_ENV checks.

const isDev = process.env.NODE_ENV === "development";

export const logError = (...args) => {
  if (isDev && typeof console !== "undefined") {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};

export const logDebug = (...args) => {
  if (isDev && typeof console !== "undefined") {
    // eslint-disable-next-line no-console
    console.debug(...args);
  }
};
